import { useEffect, useState } from 'react';
import { fetchPublicStats } from './publicStatsApi';

export type PublicStatsState = {
  gameCount: number | null;
  lessonCount: number | null;
  loading: boolean;
};

export type PublicGameCountState = {
  count: number | null;
  loading: boolean;
};

export function usePublicStats(): PublicStatsState {
  const [gameCount, setGameCount] = useState<number | null>(null);
  const [lessonCount, setLessonCount] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    void fetchPublicStats()
      .then((stats) => {
        if (cancelled) {
          return;
        }
        if (stats.gameCount > 0) {
          setGameCount(stats.gameCount);
        }
        if (stats.lessonCount > 0) {
          setLessonCount(stats.lessonCount);
        }
      })
      .catch(() => {
        // Leave counts null when /public/stats is unavailable.
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { gameCount, lessonCount, loading };
}

export function usePublicGameCount(): PublicGameCountState {
  const { gameCount, loading } = usePublicStats();
  return { count: gameCount, loading };
}
